<template>
<div>
  <div class="d-flex">
    <div class="col-md-3">
          <Panelenterprise :data="data"></Panelenterprise>
    </div>
    <div class="tab-enterpirse col-md-9">
        <b-tabs v-model="tabIndex">
           <b-tab :title="'Tabela de preços'">
            <template slot="title">
              <div><span class="d-md-down-none pl-1 text-third text-tabs">Tipo e Endereço</span></div>
            </template>
            <Typeaddressenterprise v-on:save="saveEnterprise" :data="data"></Typeaddressenterprise>
          </b-tab>
          <b-tab :title="'Tabela de preços'">
            <template slot="title">
              <div><span class="d-md-down-none pl-1 text-third text-tabs">Mídias</span></div>
            </template>
            <Boardmediaenterprise :data="data"></Boardmediaenterprise>
          </b-tab>
            <b-tab :title="'Tabela de preços'">
            <template slot="title">
              <div><span class="d-md-down-none pl-1 text-third text-tabs">Espelho de Venda</span></div>
            </template>
            <Tableprice rice :data="data" :id="id"></Tableprice>
          </b-tab>
          <b-tab :title="'Tabela de preços'">
            <template slot="title">
              <div><span class="d-md-down-none pl-1 text-third text-tabs">Tabelas de Preço</span></div>
            </template>
            <Mirrorsalesenterprise :title="'Detalhe do Empreendimento'" :dataEnterprise="data"></Mirrorsalesenterprise>
          </b-tab>
            <b-tab :title="'Tabela de preços'">
            <template slot="title">
              <div><span class="d-md-down-none pl-1 text-third text-tabs">Evolução de Obra</span></div>
            </template>
            <Evolutionwork :data="data"></Evolutionwork>
          </b-tab>
            <b-tab :title="'Tabela de preços'">
            <template slot="title">
              <div><span class="d-md-down-none pl-1 text-third text-tabs">Torres / Quadras</span></div>
            </template>
            <Towerscourt :dataTowers="data"></Towerscourt>
          </b-tab>
           <b-tab :title="'Tabela de preços'">
            <template slot="title">
              <div><span class="d-md-down-none pl-1 text-third text-tabs">Imobiliária</span></div>
            </template>
            <Tabenterprise :dataCredenciada="data"></Tabenterprise>
          </b-tab>
        </b-tabs>
    </div>
</div>
</div>
</template>

<script>
import Detailsenterprise from './detailsenterprise'
export default Detailsenterprise
</script>

<style scoped>
.text-tabs{
    font-size: 16px;
    margin-left: 5px;
    font-weight: bold;
    margin-top: 10px;
}
.tab-content {
    margin-top: -1px;
    height: 136%;
    height: 705px;
    background: #fff;
    border: 1px solid #cfd8dc;
}
.container-add-button{
    position: fixed;
    bottom: calc(50px - 1vh);
    right: 15px;
}

.tab-enterpirse{
  font-family: 'Segoe UI';
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/detailsenterprise/detailsenterprise.vue